export declare type PolylineModeType = 'DEFAULT' | 'SUBTRACT';